import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import {
  getBrandStore,
  getBrandUsers,
  getStoreUsersStoreConfig,
} from "../../../services/StoreUsers/PostStoreUsers";
import { formatDate } from "../../../constants/DateUtil/DateUtil";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import StoreUserStatusChange from "./StoreUserStatusChange";
import StoreUserAddModal from "./StoreUserAddModal";
import AdminMenu from "../../AdminMenu";
import { getStoreCustomerIdConfig } from "../../../services/StoreCustomerId/StoreCustomerId";

const StoreCustomerIdConfigList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, StoreData } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const [storeUserData, setStoreUserData] = useState([]);
  const [storeCustomerIdList, setStoreCustomerIdList] = useState([]);
  const [storeUserAddModalVisible, setStoreUserAddModalVisible] =
    useState(false);
  const [loading, setLoading] = useState(false);

  const { brandProfileData, userProfileRole } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const fetchStoreCustomerIdConfig = () => {
    setLoading(true);
    getStoreCustomerIdConfig(brandId, id)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreCustomerIdList(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreCustomerIdConfig();
  }, []);

  const receiveDataFromBrandStoreUserStatusChange = ({ success }) => {
    if (success) {
      fetchStoreCustomerIdConfig();
    }
  };

  const renderStoreUserCardItem = (data) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Prefix :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {data.prefix}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Last Customer Id :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {data.lastCustomerId}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Postfix :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {data.postfix}
                    </p>
                  </div>
                  <div
                    className="mr-4 mt-2"
                    onClick={() =>
                      navigate("/store-customer-id-config-add", {
                        state: {
                          id: id,
                          item: data,
                          StoreData: StoreData,
                        },
                      })
                    }
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/StoreConfigList", {
                      state: {
                        id: id,
                        StoreData: StoreData,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Store Customer Id Config
              </p>
            </div>
          </div>
          {userRole === "BY_FRANCHISE_ADMIN" ? (
            ""
          ) : (
            <div>
              {storeCustomerIdList?.id === null && (
                <div
                  className="flex justify-content-center align-items-center cursor-pointer mr-4"
                  onClick={() =>
                    navigate("/store-customer-id-config-add", {
                      state: {
                        id: id,
                        StoreData: StoreData,
                      },
                    })
                  }
                >
                  <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
                </div>
              )}
            </div>
          )}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : storeCustomerIdList?.id ? (
          <div>
            <div>{renderStoreUserCardItem(storeCustomerIdList)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Data Found</p>
          </div>
        )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default StoreCustomerIdConfigList;
